import { type DependencyList, type EffectCallback, useLayoutEffect } from 'react';
import { isClient } from '#/utils/general';

function useIgnoreEffect(_effect: EffectCallback, _deps?: DependencyList) {
  // do nothing
}

/**
 * A safe version of `useLayoutEffect` that noops on the server.
 */
export const useSafeLayoutEffect = isClient() ? useLayoutEffect : useIgnoreEffect;
